import { ReactNode, useEffect, useState } from "react"

import { setThemeNameObs, ThemeContext } from "."
import { setThemeClass } from "./setThemeClass"
import { ThemeName, themes } from "./themes"

const STORAGE_KEY = "themeName"

interface Props {
  storage?: typeof localStorage | typeof sessionStorage
  children: ReactNode
}

export const ThemeProvider = ({ storage = localStorage, children }: Props) => {
  const [themeName, setThemeNameState] = useState<ThemeName>(
    () => (storage.getItem(STORAGE_KEY) as ThemeName) || ThemeName.Dark,
  )

  const setThemeName = (name: ThemeName) => {
    setThemeNameState(name)
    setThemeNameObs(name)
  }

  useEffect(() => {
    const setThemeFromStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY) {
        const themeName = storage.getItem(STORAGE_KEY) as ThemeName

        if (themeName && themes[themeName] != null) {
          setThemeName(themeName)
        }
      }
    }

    window.addEventListener("storage", setThemeFromStorage)
    return () => {
      window.removeEventListener("storage", setThemeFromStorage)
    }
  }, [storage])

  useEffect(() => {
    storage.setItem(STORAGE_KEY, themeName)
    setThemeClass(themeName)
  }, [storage, themeName])

  // set themeColor in index.html (used for PWA title bar)
  useEffect(() => {
    const head = document.getElementById("themeColor")
    head &&
      head.setAttribute(
        "content",
        themes[themeName].color["Colors/Background/bg-primary"],
      )
  }, [themeName])

  return (
    <ThemeContext.Provider value={{ themeName, setThemeName }}>
      {children}
    </ThemeContext.Provider>
  )
}
